export const pricing = [
  {
    type: 'trial',
    name: 'pricing.trial.name',
    subName: 'pricing.trial.subName',
    level: [
      'pricing.levels.item_1',
      'pricing.levels.item_2',
      'pricing.levels.item_3',
      'pricing.levels.item_4',
      'pricing.levels.item_5'
    ],
    advantages: [
      'pricing.trial.advantages.item_1'
    ],
    commission: [
      'pricing.trial.commission.item_1',
      // 'pricing.trial.commission.item_2',
      // 'pricing.trial.commission.item_3',
      // 'pricing.trial.commission.item_4',
      // 'pricing.trial.commission.item_5'
    ]
  },
  {
    type: 'basic',
    name: 'pricing.basic.name',
    subName: 'pricing.trial.subName',
    level: [
      'pricing.levels.item_1',
      'pricing.levels.item_2',
      'pricing.levels.item_3',
      'pricing.levels.item_4',
      'pricing.levels.item_5'
    ],
    advantages: [
      'pricing.basic.advantages.item_1',
      'pricing.basic.advantages.item_2',
      'pricing.basic.advantages.item_3',
      'pricing.basic.advantages.item_4',
      // 'pricing.basic.advantages.item_5',
    ],
    commission: [
      'pricing.basic.commission.item_1'
    ]
  },
  {
    type: 'premium',
    name: 'pricing.premium.name',
    subName: 'pricing.trial.subName',
    level: [
      'pricing.levels.item_1',
      'pricing.levels.item_2',
      'pricing.levels.item_3',
      'pricing.levels.item_4',
      'pricing.levels.item_5'
    ],
    advantages: [
      'pricing.premium.advantages.item_1',
      'pricing.premium.advantages.item_2',
      'pricing.premium.advantages.item_3',
      'pricing.premium.advantages.item_4',
      'pricing.premium.advantages.item_5'
    ],
    commission: [
      'pricing.premium.commission.item_1',
      'pricing.premium.commission.item_2'
    ]
  },
]
